import React from 'react'
import { Box, IconButton, Tooltip } from '@mui/material'
import { REPAIR_CATEGORY_ICON_OPTIONS } from './repairCategoryIcons'

interface RepairCategoryIconPickerProps {
  value: string | null
  onChange: (iconKey: string | null) => void
}

/** Grid of icon buttons; selected one is highlighted. Null clears the selection. */
export const RepairCategoryIconPicker: React.FC<RepairCategoryIconPickerProps> = ({
  value,
  onChange,
}) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(40px, 1fr))',
        gap: 0.5,
      }}
    >
      {REPAIR_CATEGORY_ICON_OPTIONS.map(({ key, label, Icon }) => {
        const isSelected = value === key
        return (
          <Tooltip key={key} title={label}>
            <IconButton
              size="small"
              color={isSelected ? 'error' : 'default'}
              onClick={() => onChange(isSelected ? null : key)}
              sx={{
                border: 1,
                borderColor: isSelected ? 'error.main' : 'divider',
                borderRadius: 1,
                bgcolor: isSelected ? 'error.light' : 'background.paper',
                color: isSelected ? 'error.contrastText' : 'text.secondary',
                '&:hover': { bgcolor: isSelected ? 'error.light' : 'action.hover' },
              }}
            >
              <Icon fontSize="small" />
            </IconButton>
          </Tooltip>
        )
      })}
    </Box>
  )
}

export default RepairCategoryIconPicker
